// extracted by mini-css-extract-plugin
export default {"content":"wG-z"};